var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.code && _vm.payload)?_c('div',[_c(_vm.dynamicComp,{key:_vm.componentKey,tag:"component",attrs:{"value":_vm.payload},on:{"input":function($event){return _vm.$emit('input', $event)},"run_action":_vm.handleRunAction}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }